export function getConfirmationPageKey(screener: Screener, status: string) {
  let key: string;
  if (status == 'requested') {
    key = screener.style == 'video_call' ? 'requested_to_schedule' : 'requested_to_get_started';
  } else if (screener.screener_type === 'pre') {
    key = 'screener';
  } else if (screener.style === 'panel') {
    key = 'panel';
  } else if (screener.style === 'unmoderated_test') {
    key = 'unmoderated';
  } else {
    key = 'survey';
  }
  return key;
}

export function getConfirmationType(
  participation: Participation | null
): 'auto_disqualification' | 'auto_qualification' | 'manual_review' | 'default' {
  let type: 'auto_disqualification' | 'auto_qualification' | 'manual_review' | 'default' = 'default';

  if (participation) {
    const lastActivity = participation.activities?.[0];
    if (lastActivity?.key === 'rejected.auto_disqualification') {
      type = 'auto_disqualification';
    } else if (lastActivity?.key === 'requested.auto_qualification') {
      type = 'auto_qualification';
    } else if (participation.status === 'rejected') {
      type = 'auto_disqualification';
    } else if (participation.status === 'requested') {
      type = 'auto_qualification';
    } else {
      type = 'manual_review';
    }
  }

  return type;
}
